import router from '@/router';

//set element color to match route custom-color meta attribute
export default {
  inserted(el: HTMLElement): void {
    let customColors: string;
    try {
      customColors = router.currentRoute.meta
        ? router.currentRoute.meta.customColors[0]
        : 'inherit';
    } catch (e) {
      customColors = 'inherit';
    }
    el.style.setProperty('color', customColors, 'important');
  },
};
